export default {
    receivables: [],
    error: false,
    errorMessage: '',
    totalReceivables: 0,
    params: {
        paginate: true,
        page: 1,
        perPage: 15,
        sortBy: 'invoice_id',
        sort: 'ASC',
        warehouse: 0,
        color_text: "color-default",
        color_backg: " ",
        address: "",
        telephone: "",
        style_line : "linea-sup",
        background_c : "default",
        email: "",
        company: "",
        color_text_soft: "color-default"
    },
}



// WEBPACK FOOTER //
// ./src/b2b/modules/receivable/state.js